const state = {
    businessProfiles: []
};

const getters = {
    businessProfiles: (state) => state.businessProfiles,
};

const actions = {
    onBusinessProfilesSnapshot({ commit, rootGetters }, changes){
        commit('setBusinessProfiles', changes);
    }
};

const mutations = {
    setBusinessProfiles:  (state, changes) => {
        changes.forEach((change) => {
          let data = change.doc.data();
          if (data.businessName != "") {
            if (change.type === "added") {
              state.businessProfiles.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            } else if (change.type == "modified") {
              //Replace the old business profile object within the business profile array with the modified object
              state.businessProfiles.forEach((businessProfile, i) => {
                if (businessProfile.id == change.doc.id) {
                  //Remove the old object of the modified business profile
                  state.businessProfiles.splice(i, 1);
                  //Add the modified business profile
                  state.businessProfiles.push({
                    ...data,
                  });
                }
              });
            } else if (change.type == "removed") {
              //Remove the business profile object from the business profiles array
              state.businessProfiles.forEach((businessProfile, i) => {
                if (businessProfile.id == change.doc.id) {
                  //Remove the object of the removed business profile
                  state.businessProfiles.splice(i, 1);
                }
              });
            }
          }
        });
      },
};

export default {
   state, getters, actions, mutations
}
